import { Referrals } from '@interfaces/share-links.interface'

export const getReferralsLink = [
  {
    general_link_reference_id: null,
    title: 'Link Geral',
    url: 'https://bit.ly/3WbX7Ok',
  },
] as unknown as Referrals[]
